import styled from "@emotion/styled";
import { ReactComponent as icon} from "../../../../../../images/Details-01.svg";

export const DetailsIcon = styled(icon)`
    width: 24px;
    cursor: pointer;
`;